module.exports = {
      id: "palo-english-usage",
      viewBox: "0 0 230 78",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#palo-english",
      toString: function () {
        return this.url;
      }
    }